import { getDocOgImageRelativePath, getDocPageUrlPath } from "./og-image";
import { SITE_TITLE, SITE_URL } from "./site";

export type DocHeadPage = {
  path: string;
  title: string;
  description?: string;
};

type HeadMeta = {
  title?: string;
  name?: string;
  property?: string;
  content?: string;
};

type HeadLink = {
  rel: "canonical";
  href: string;
};

export type DocHead = {
  meta: HeadMeta[];
  links: HeadLink[];
};

export function buildDocHead(page: DocHeadPage): DocHead {
  const pagePath = getDocPageUrlPath(page.path);
  const canonicalUrl = `${SITE_URL}/${pagePath}`;
  const ogImageUrl = `${SITE_URL}/${getDocOgImageRelativePath(pagePath)}`;
  const meta: HeadMeta[] = [{ title: `${page.title} - ${SITE_TITLE}` }];

  if (page.description) {
    meta.push({ name: "description", content: page.description });
  }

  meta.push(
    { property: "og:title", content: page.title },
    ...(page.description
      ? [{ property: "og:description", content: page.description }]
      : []),
    { property: "og:url", content: canonicalUrl },
    { property: "og:site_name", content: SITE_TITLE },
    { property: "og:type", content: "website" },
    { property: "og:image", content: ogImageUrl },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:title", content: page.title },
    ...(page.description
      ? [{ name: "twitter:description", content: page.description }]
      : []),
    { name: "twitter:image", content: ogImageUrl },
  );

  return {
    meta,
    links: [{ rel: "canonical", href: canonicalUrl }],
  };
}
